module.exports = __webpack_public_path__ + "img/4.100b0e98.jpg";